import { render } from "./InterfaceIntegratedEditorSearch.vue?vue&type=template&id=2667aa7c&scoped=true"
import script from "./InterfaceIntegratedEditorSearch.vue?vue&type=script&lang=js"
export * from "./InterfaceIntegratedEditorSearch.vue?vue&type=script&lang=js"

import "./InterfaceIntegratedEditorSearch.vue?vue&type=style&index=0&id=2667aa7c&scoped=true&lang=scss"

import exportComponent from "/var/www/blocks/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2667aa7c"]])

export default __exports__